import React from 'react'
import FeaturedContent from './children/FeaturedContent'

const RiverTopContent = ({ riverConfig, riverKey }) => {
  const {
    showFeaturedContent = false,
    showSingleFeaturedContent = false,
    title
  } = riverConfig

  return (
    <>
      {(showFeaturedContent || showSingleFeaturedContent) && (
        <FeaturedContent
          single={showSingleFeaturedContent}
          title={title}
          riverKey={riverKey}
        />
      )}
    </>
  )
}

export default RiverTopContent
